"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            suggestedProviders: [],
            providers: null,
            doSetup: null,
            showDialog: false
        };
        this.onFetchProviders();
        this.onFetchSuggestions();
    },
    onSetup: function (type, app) {
        app.payload = { action: type == 'configure' ? 'configure' : 'setup' };
        this.state.doSetup = app;
    },
    onRemove: function (index) {
        this.state.providers.splice(index, 1);
        this.setStateDirty('providers');
    },
    onDialog: function (options) {
        this.state.showDialog = options;
    },
    onCloseSetup: function () {
        this.state.doSetup = false;
    },
    onFetchProviders: async function () {
        try {
            const {error, message, results} = await Request(`/extension/search?query=live-session`);
            if (error)
                throw new Error(message);
            this.state.providers = results;
        } catch (error) {
            console.log('Error Fetching Live-session Apps: ', error);
        }
    },
    onFetchSuggestions: async function () {
        try {
            const {error, message, results} = await MPSRequest(`/extension/search?query=live-session`);
            if (error)
                throw new Error(message);
            this.state.suggestedProviders = results;
        } catch (error) {
            console.log('Error Fetching suggestions list of Live-session providers: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LiveSessions/Admin/Providers/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Provider_template = require("./components/Provider.marko"),
    Provider_tag = marko_loadTag(Provider_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    SetupShell_template = require("../../../../components/SetupShell.marko"),
    SetupShell_tag = marko_loadTag(SetupShell_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    DialogModal_template = require("../../../../../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    Wrapper_Admin_template = require("../../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("2258e8"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("img", {
        src: "/images/illustration/live-session-providers.png",
        "class": "img-fluid w-100",
        alt: "illustration"
      }, "24", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { page }) {
        if (state.providers === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.providers.length) {
          out.be("div", marko_attrs0, "2", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              col: [
                  {
                      class: "col",
                      renderBody: function(out) {
                        out.be("h5", null, "5", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Add & Manage Live Sessions Providers");
                            }
                          }, out, __component, "6");

                        out.ee();

                        out.n(marko_node0, component);

                        out.be("p", marko_attrs1, "8", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Choose, install and configure your favorate live-session providers like Zoom, Google Meet, Microsoft Teams, Airmeet, ... from our");
                            }
                          }, out, __component, "9");

                        out.t(" ");

                        route_link_tag({
                            href: "/marketplace/search?query=live-session",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Marketplace"
                                }, out, __component, "11");
                            }
                          }, out, __component, "10");

                        out.t(" ");

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("at a click. We'll provide you with all required instructions to help you set them up in a minute.");
                            }
                          }, out, __component, "12");

                        out.ee();

                        out.n(marko_node1, component);

                        Row_tag(marko_mergeNestedTagsHelper({
                            renderBody: function(out, $nestedTagRow$0) {
                              var $for$0 = 0;

                              marko_forOf(state.suggestedProviders, function(app, index) {
                                var $keyScope$0 = "[" + (($for$0++) + "]");

                                Row_col_nested_tag({
                                    ns: "col-4",
                                    qs: "col-5",
                                    hs: "col-8",
                                    renderBody: function(out) {
                                      Provider_tag({
                                          app: app
                                        }, out, __component, "16" + $keyScope$0, [
                                        [
                                          "setup",
                                          "onSetup",
                                          false,
                                          [
                                              "walkthrough"
                                            ]
                                        ]
                                      ]);
                                    }
                                  }, $nestedTagRow$0);
                              });
                            }
                          }), out, __component, "14");

                        out.n(marko_node2, component);

                        out.n(marko_node3, component);

                        out.n(marko_node4, component);

                        route_link_tag({
                            class: "d-flex align-items-center font-medium-2",
                            href: "/help/live-session#providers",
                            renderBody: function(out) {
                              Locale_tag({
                                  renderBody: function(out) {
                                    out.t("Click here for more information");
                                  }
                                }, out, __component, "21");

                              Bx_tag({
                                  type: "right-arrow-alt",
                                  class: "ml-2 font-medium-5"
                                }, out, __component, "22");
                            }
                          }, out, __component, "20");
                      }
                    },
                  {
                      class: "col-5 text-center",
                      renderBody: function(out) {
                        out.n(marko_node5, component);
                      }
                    }
                ]
            }, out, __component, "3");

          out.ee();
        } else {
          out.be("div", null, "25", component);

          Row_tag(marko_mergeNestedTagsHelper({
              renderBody: function(out, $nestedTagRow$1) {
                var $for$1 = 0;

                marko_forOf(state.providers, function(app, index) {
                  var $keyScope$1 = "[" + (($for$1++) + "]");

                  Row_col_nested_tag({
                      ns: "col-md-3 col-12",
                      qs: "col-4",
                      hs: "col-6",
                      renderBody: function(out) {
                        Provider_tag({
                            app: app,
                            active: true
                          }, out, __component, "28" + $keyScope$1, [
                          [
                            "configure",
                            "onSetup",
                            false,
                            [
                                "configure"
                              ]
                          ],
                          [
                            "setup",
                            "onSetup",
                            false,
                            [
                                "walkthrough"
                              ]
                          ],
                          [
                            "remove",
                            "onRemove",
                            false,
                            [
                                index
                              ]
                          ],
                          [
                            "dialog",
                            "onDialog",
                            false
                          ]
                        ]);
                      }
                    }, $nestedTagRow$1);
                });
              }
            }), out, __component, "26");

          out.ee();
        }

        if (state.doSetup) {
          SetupShell_tag({
              meta: state.doSetup
            }, out, __component, "29", [
            [
              "setup-done",
              "onFetchProviders",
              false
            ],
            [
              "dismiss",
              "onCloseSetup",
              false
            ]
          ]);
        }

        if (state.showDialog) {
          const { message, actions, ...rest } = state.showDialog

          DialogModal_tag(marko_assign({
              message: message,
              actions: actions
            }, rest), out, __component, "30", [
            [
              "dismiss",
              "onDialog",
              false,
              [
                  false
                ]
            ]
          ]);
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
